// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","Storefront":"HBiJOe","fadeInFrames":"_2H4NgY"};